export enum ComparisonMode {
  And = "And",
  Or = "Or",
  Not = "Not",
}

export enum Context {
  Actions = "actions",
  Fields = "fields",
}
